export const stockListSelector = (state) => state.stock.list;
export const stockSelector = (state) => state.stock.current;
